import {
  ImageUploadResult,
  ListImageUploadsResult,
} from '../menu-service.types';

export const uploads: ImageUploadResult[] = [
  {
    id: '4',
    clientId: '1234',
    uploadId: '20231030093403000',
    type: 'CATALOG' as const,
    dateCreated: '2023-10-30T09:34:03.000Z',
    dateUpdated: '2023-10-30T10:34:03.000Z',
    status: 'UPLOADING' as const,
    publish: false,
    processedFiles: [
      {
        filename: '/i/uploadId4/md/image3.jpg',
        status: 'UPLOADING' as const,
        matches: [],
      },
    ],
  },
  {
    id: '3',
    clientId: '1234',
    uploadId: '20231030083403000',
    type: 'GROUP' as const,
    dateCreated: '2023-10-30T08:34:03.000Z',
    dateUpdated: '2023-10-30T09:34:03.000Z',
    status: 'PROCESSING' as const,
    publish: true,
    processedFiles: [],
  },
  {
    id: '2',
    clientId: '1234',
    uploadId: '20231029093403000',
    type: 'GROUP' as const,
    dateCreated: '2023-10-29T09:34:03.000Z',
    dateUpdated: '2023-10-29T10:34:03.000Z',
    status: 'PUBLISHING' as const,
    publish: true,
    processedFiles: [],
  },
  {
    id: '1',
    clientId: '1234',
    uploadId: '20231028093403000',
    type: 'ITEM' as const,
    dateCreated: '2023-10-28T09:34:03.000Z',
    dateUpdated: '2023-10-28T10:34:03.000Z',
    status: 'COMPLETE' as const,
    publish: true,
    processedFiles: [
      {
        filename: '/i/uploadId4/sm/image1.jpg',
        status: 'PROCESSED' as const,
        url: 'https://notareallink.jpg',
        matches: [
          {
            id: 'match3',
            title: 'zzz',
          },
          {
            id: 'match8',
            title: 'zzz',
          },
          {
            id: 'match1',
            title: 'Product 1',
          },
          {
            id: 'match2',
            title: 'Product 2',
          },
          {
            id: 'match4',
            title: 'aaa',
          },
          {
            id: 'match5',
            title: 'bbb',
          },
          {
            id: 'match6',
            title: 'ddd',
          },
          {
            id: 'match7',
            title: 'ccc',
          },
        ],
      },
      {
        filename: '/i/uploadId4/sm/image2.jpg',
        status: 'ERROR' as const,
        statusMessage: 'Timed out or something I dunno',
      },
      {
        filename: '/i/uploadId4/md/image3.jpg',
        status: 'UPLOADING' as const,
        matches: [],
      },
      {
        filename: '/i/uploadId4/md/image4.jpg',
        status: 'UPLOADED' as const,
        matches: [],
      },
      {
        filename: '/i/uploadId4/md/image5.jpg',
        status: 'QUEUED' as const,
        matches: [],
      },
    ],
  },
];

export const imageUploads: ListImageUploadsResult = {
  paging: {
    total: 3,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
  uploads,
};
